export default {
    // Common
    common: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        edit: 'Edit',
        add: 'Add',
        search: 'Search',
        reset: 'Reset',
        submit: 'Submit',
        back: 'Back',
        loading: 'Loading...',
        success: 'Operation successful',
        failed: 'Operation failed',
        tip: 'Tip',
        warning: 'Warning',
        error: 'Error',
        close: 'Close',
        change: 'Change',
        modify: 'Modify',
        bind: 'Bind',
        unbind: 'Rebind',
        verify: 'Verify',
        query: 'Query',
        exit: 'Exit',
        systemTip: 'System Tip',
        contactAdmin: 'Please contact administrator',
        or: 'Or use these'
    },
    // Login
    login: {
        title: 'User Login',
        username: 'Username',
        password: 'Password',
        login: 'Login',
        register: 'Register',
        forgetPassword: 'Forgot Password',
        rememberMe: 'Remember Me',
        loginSuccess: 'Login successful',
        loginFailed: 'Login failed',
        loginExpired: 'Login expired, please login again',
        phoneLogin: 'SMS Login',
        emailLogin: 'Email Login',
        accountLogin: 'Account Login',
        verifyCode: 'Verify Code',
        getVerifyCode: 'Get Code',
        sendVerifyCode: 'Send Code',
        resendAfter: 's to resend',
        resendAfterSend: 's to resend',
        phone: 'Phone',
        email: 'Email',
        account: 'Account',
        createAccount: 'Create Account',
        enterPhoneOrAccount: 'Enter phone, account or email',
        enterPassword: 'Enter password',
        enterPhone: 'Enter phone number',
        enterEmail: 'Enter email',
        enterVerifyCode: 'Enter verify code',
        codeSentToPhone: 'Code sent to your phone!',
        codeSentToEmail: 'Code sent to your email!',
        enterPhoneOrAccountHint: 'Enter phone or account',
        enterAccount: 'Enter account'
    },
    // Register
    register: {
        title: 'User Registration',
        confirmPassword: 'Confirm Password',
        reenterPassword: 'Re-enter Password',
        registerSuccess: 'Registration successful',
        registerFailed: 'Registration failed',
        phoneRegister: 'Phone Registration',
        emailRegister: 'Email Registration',
        agreeAndRead: 'I have agreed and read',
        userAgreement: 'User Agreement and Privacy Policy',
        pleaseAgree: 'Please agree to User Agreement and Privacy Policy',
        passwordDifferent: 'Passwords do not match'
    },
    // Account
    account: {
        title: 'Account',
        accountManage: 'Account Management',
        changePassword: 'Change Password',
        oldPassword: 'Old Password',
        newPassword: 'Password',
        confirmPassword: 'Confirm Password',
        phone: 'Phone',
        email: 'Email',
        newPhone: 'New Phone',
        newEmail: 'New Email',
        enterUsername: 'Enter username',
        enterOldPassword: 'Enter old password',
        enterPassword: 'Enter password',
        enterPasswordAgain: 'Enter password again',
        enterPhone: 'Enter phone number',
        enterNewPhone: 'Enter new phone number',
        enterEmail: 'Enter email',
        enterNewEmail: 'Enter new email',
        enterVerifyCode: 'Enter verify code',
        passwordNotMatch: 'Passwords do not match!',
        changeSuccess: 'Changed successfully',
        modifySuccess: 'Modified successfully',
        bindSuccess: 'Bound successfully',
        unbindSuccess: 'Rebound successfully',
        deleteSuccess: 'Account deleted successfully',
        disconnectSuccess: 'Disconnected successfully',
        codeSentCheckPhone: 'Code sent, please check your phone',
        codeSentCheckEmail: 'Code sent, please check your email',
        codeSentCheckBoundPhone: 'Code sent, please check the phone bound to this account',
        codeSentCheckBoundEmail: 'Code sent, please check the email bound to this account',
        exitLogin: 'Logout',
        deleteAccount: 'Delete Account',
        thirdPartyAccounts: 'Linked Third-party Accounts',
        platform: 'Platform',
        createDate: 'Create Date',
        disconnect: 'Disconnect',
        other: 'Other',
        registerTime: 'Register Time',
        loginPlatform: 'Login Platform',
        noPasswordWarning: 'Your account has no password set. For convenience and security, please set a password',
        noPhoneWarning: 'Your account has no phone bound. For convenience and security, please bind a phone',
        noEmailWarning: 'Your account has no email bound. For convenience and security, please bind an email',
        deleteConfirm:
            'Are you sure to delete account {account}? After deletion, there is a 15-day buffer period. If you login again within 15 days, the account will be reactivated. If not reactivated after 15 days, the account will be permanently deleted!',
        disconnectConfirm:
            'Are you sure to disconnect {platform} from your account? After disconnecting, you will not be able to use this platform for quick login'
    },
    // Forget Password
    forgetPwd: {
        title: 'Forgot Password',
        recoverAccount: 'Recover Account',
        enterRecoverAccount: 'Enter account to recover',
        enterPhoneQuery: 'Enter phone to query',
        enterEmailQuery: 'Enter email to query',
        forgetAccount: 'Forgot Account',
        forgetPhone: 'Forgot Phone',
        forgetEmail: 'Forgot Email',
        noUsernameSet: 'This account has no username set. Please set it after login!',
        noPhoneOrEmail: 'This account has no phone or email bound. Please contact administrator!',
        passwordDifferent: 'Passwords are different',
        enterNewPassword: 'Enter password',
        reenterPassword: 'Re-enter password',
        codeSentTo: 'Code sent to {contact}',
        modifySuccessLogin: 'Modified successfully, logging in...'
    },
    // Menu
    menu: {
        home: 'Home',
        account: 'Account',
        logout: 'Logout'
    },
    // Validation
    validation: {
        required: 'This field is required',
        emailFormat: 'Please enter a valid email address',
        phoneFormat: 'Please enter a valid phone number',
        passwordLength: 'Password must be 6-20 characters',
        passwordNotMatch: 'Passwords do not match'
    },
    header: {
        customerAccount: 'Support',
        region: 'Server',
        china: 'China',
        overseas: 'Overseas',
        confirmSwitchRegion: 'Switching servers requires re-login. Are you sure you want to switch to \'{region}\' server?'
    },
    // Footer
    footer: {
        copyright: 'Copyright © 2023 COTTON GAME. All rights reserved',
        healthAdvice: 'Gaming Advisory: Resist inappropriate games, reject pirated games, protect yourself, and beware of scams.',
        moderateGaming:
            'Moderate gaming is good for the mind; excessive gaming harms the body. Manage your time wisely and enjoy a healthy life.'
    },
    // Request
    request: {
        networkError: 'Network Error',
        timeout: 'Request Timeout',
        authExpired: 'Authentication expired, please login again!',
        docSuccess: 'Document request successful'
    },
    // Router titles
    router: {
        home: 'Home',
        account: 'Account Management',
        login: 'Login',
        phoneLogin: 'Phone Login',
        emailLogin: 'Email Login',
        forgetPwd: 'Forgot Password',
        phoneRegister: 'Phone Registration',
        emailRegister: 'Email Registration'
    },
    // Home
    home: {
        personalInfo: 'Personal Info',
        giftCodeRedeem: 'Gift Code Redeem'
    },
    // Gift Code
    giftCode: {
        title: 'Gift Code Redeem',
        selectProject: 'Select Game',
        selectProjectPlaceholder: 'Please select a game',
        selectProjectRequired: 'Please select a game',
        code: 'Gift Code',
        enterCode: 'Enter gift code',
        enterCodeRequired: 'Please enter gift code',
        redeem: 'Redeem',
        redeemSuccessTitle: 'Redeem Successful',
        redeemSuccessTip: 'Redeem successful! Please close the game and re-enter, the rewards will be automatically sent to your account.'
    }
};
